import React from 'react';
import { Row, Col, Alert, Icon, DisplayField, Card } from '@digitools/honest-react';
import { useTranslation } from 'react-i18next';
import checkDate from '../../../utilities/checkDate';
import useAuthentication from '../../../../../hooks/useAuthentication';
import titleCase from 'src/packages/status/utilities/titleCase';
import styled from 'styled-components';
import { PENDING_STATUS_CODES, DENIED_STATUS_CODES } from '../../../constants/StatusCodes';
const StatusMessage = styled('div') `
    color: ${({ theme }) => theme?.palette?.darkGray};
    font-style: italic;
    font-size: .9rem;
    margin-top: .75rem;
    margin-bottom: .75rem;
`;
const StyledFlexContainerDiv = styled('div') `
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
    column-gap: 1.1%;
    row-gap: 10px;
    margin-bottom: 10px;
    @media (max-width: 440px) {
        column-gap: 4%;
      }
`;
const StyledFourthColumnDiv = styled('div') `
  @media (min-width: 440px) {
    margin:0px 2px 0px 2px;
    flex: 0 0 23.7%;
  }
  @media (max-width: 440px) {
    flex: 0 0 48%;
    margin-bottom: 15px;
  }
`;
const Error = () => (<Alert type={'error'}>
        <span>
            <strong>Error!</strong>&nbsp;Unable to load claims dates.
        </span>
    </Alert>);
const ClaimDatesCard = ({ claim }) => {
    const { user } = useAuthentication();
    const { t } = useTranslation();
    const isSTDLTD = claim.prodType === 'STD' || claim.prodType === 'Short Term Disability' || claim.prodType === 'LTD' || claim.prodType === 'Long Term Disability';
    //if it's not the status we want, we will render it, otherwise hide
    const isNotPendingInprogressStatus = !(PENDING_STATUS_CODES.includes(claim.clmSttusCde));
    const isNotDeniedStatus = !(DENIED_STATUS_CODES.includes(claim.clmSttusCde));
    if (!claim) {
        return <Error />;
    }
    ;
    return (<Card data-testid={'claimDates'} selectable={false} fontSize='large' small={true}>
            <StyledFlexContainerDiv>
            
                <StyledFourthColumnDiv>
                    <DisplayField label={titleCase(t('claimReceivedText').toString())} value={claim.clmRecdDte && claim.clmRecdDte.split(' ')[0]}/>
                </StyledFourthColumnDiv>
                <StyledFourthColumnDiv>
                    <DisplayField label={titleCase(t('lastDateWorkedText').toString())} value={checkDate(claim.clmLastWrkDte)}/>
                </StyledFourthColumnDiv>
                <StyledFourthColumnDiv>
                    <DisplayField data-private={true} label={titleCase(t('dateOfDisabilityText').toString())} value={checkDate(claim.clmDisabDte)}/>
                </StyledFourthColumnDiv>
                {isNotPendingInprogressStatus &&
            <StyledFourthColumnDiv>
                        <DisplayField data-private={true} label={titleCase(t('determinationDateText').toString())} value={checkDate(claim.clmDtrmDte)}/>
                    </StyledFourthColumnDiv>}
            
                {isNotDeniedStatus &&
            <StyledFourthColumnDiv>
                        <DisplayField label={titleCase(t('benefitsBeginText').toString())} value={checkDate(claim.benBeginDte)}/>
                    </StyledFourthColumnDiv>}
                {(isNotPendingInprogressStatus && isNotDeniedStatus) &&
            <StyledFourthColumnDiv>
                        <DisplayField label={titleCase(t('benefitsEndText').toString())} value={checkDate(claim.benEndDte)}/>
                    </StyledFourthColumnDiv>}
                {(isNotPendingInprogressStatus && isNotDeniedStatus) &&
            <StyledFourthColumnDiv>
                        <DisplayField label={user?.customerInContext?.smallMid ? `${isSTDLTD ? '*' : ''} ${titleCase(t('approvedToText').toString())}` : `${isSTDLTD ? '*' : ''} ${titleCase(t('approvedThroughText').toString())}`} value={checkDate(claim.disabApprvThruDte)}/>
                    </StyledFourthColumnDiv>}
                {isNotDeniedStatus &&
            <StyledFourthColumnDiv>
                        <DisplayField label={titleCase(t('reopenDateText').toString())} value={checkDate(claim.clmReopnDte)}/>
                    </StyledFourthColumnDiv>}
             </StyledFlexContainerDiv>

            <Row className='mb-2'>
                <Col sm={6} md={3} size={6} className='mb-2'>
                    <DisplayField label={titleCase(t('returnToWorkEstimatedText').toString())} value={checkDate(claim.clmExpecRtrnWrkDte)}/>
                </Col>
                <Col sm={6} md={3} size={6} className='mb-2'>
                    <DisplayField label={titleCase(t('returnToWorkModifiedText').toString())} value={checkDate(claim.partDtyRtrnWrkDte)}/>
                </Col>
                <Col sm={6} md={6} size={6} className='mb-2'>
                    <DisplayField label={titleCase(t('returnToWorkActualText').toString())} value={checkDate(claim.fullDtyRtrnWrkDte)}/>
                </Col>
            </Row>

            {/*This is getting hard to follow. If it's approved/closed it will show this text pending smallmid false and STDLTD*/}
            {(isNotPendingInprogressStatus && isNotDeniedStatus) ?
            (user?.customerInContext?.smallMid ? ''
                : isSTDLTD && (<Row className={'ml-0'} data-testid='date-disclaimer'>
                            <StatusMessage>
                                <Icon size='sm' name='important-message' color='grayDark' className='ml-2 mr-2'/>
                                <i>* {t('dateDisclaimerText')}</i>
                            </StatusMessage>
                        </Row>)) : ''}
        </Card>);
};
export default ClaimDatesCard;
